import { useState } from "react";
import { generateShadeHex } from "./helpers";

export function useColourCart() {
  const [cart, setCart] = useState([]);

  const addToCart = (family, colourNum, quality) => {
    const existing = cart.find(
      (c) => c.colour_number === colourNum && c.fabric_quality === quality.id
    );
    if (existing) {
      setCart(
        cart.map((c) =>
          c.colour_number === colourNum && c.fabric_quality === quality.id
            ? { ...c, quantity_meters: c.quantity_meters + quality.meters_per_bundle }
            : c
        )
      );
      return;
    }
    setCart([
      ...cart,
      {
        colour_number: colourNum,
        colour_name: `${family.name} #${colourNum}`,
        colour_family: family.name,
        colour_hex: generateShadeHex(
          family.hex,
          colourNum - family.colours[0],
          family.colours.length
        ),
        fabric_quality: quality.id,
        fabric_name: quality.name,
        panna: quality.panna,
        quantity_meters: quality.meters_per_bundle,
        meters_per_bundle: quality.meters_per_bundle,
      },
    ]);
  };

  const updateQty = (idx, delta) => {
    setCart(
      cart.map((c, i) =>
        i === idx
          ? { ...c, quantity_meters: Math.max(c.meters_per_bundle, c.quantity_meters + delta) }
          : c
      )
    );
  };

  const removeFromCart = (idx) => setCart(cart.filter((_, i) => i !== idx));

  const addItems = (items) => {
    setCart((prev) => {
      const next = [...prev];
      items.forEach((item) => {
        const at = next.findIndex(
          (c) => c.colour_number === item.colour_number && c.fabric_quality === item.fabric_quality
        );
        if (at >= 0) {
          next[at] = {
            ...next[at],
            quantity_meters: next[at].quantity_meters + item.meters_per_bundle,
          };
        } else {
          next.push({ ...item, quantity_meters: item.meters_per_bundle });
        }
      });
      return next;
    });
  };

  const clearCart = () => setCart([]);

  return { cart, addToCart, addItems, updateQty, removeFromCart, clearCart };
}
